import app from '@/app';

/* @ngInject */
function Weighing($resource) {
	return $resource(
		'api/weighings/:id',
		{ id: '@id' },
		{
			query: { method: 'GET' },
			purge: { method: 'DELETE' }
		}
	);
}

app.factory('Weighing', Weighing);
